import {
  SettingOutlined,
  TagOutlined,
  UploadOutlined,
  DatabaseOutlined,
  DashboardOutlined,
  DownloadOutlined,

} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import settingsIcono from "../../menus/icons/settingsIcono.js";
let AdminModuloConfiguracion = [
  {
    key: "Configuración del Sistema",
    path: `${APP_PREFIX_PATH}/admin/config`,
    title: "sidenav.admin.configuracion.configuracion",
    icon: SettingOutlined,
    breadcrumb: true,
    permission:['Config:general','Read:tags','Config:importar'],
    submenu: [
      {
        key: "Configuración General",
        path: `${APP_PREFIX_PATH}/admin/config`,
        title: "sidenav.admin.configuracion.general",
        icon: settingsIcono,
        breadcrumb: true,
        permission:['Config:general'],
        submenu: [],
      },
      {
        key: "Etiquetas",
        path: `${APP_PREFIX_PATH}/admin/tags/list`,
        title: "sidenav.admin.configuracion.etiquetas",
        icon: TagOutlined,
        breadcrumb: true,
        permission:['Read:tags'],
        submenu: [
          {
            key: "Taxonomias",
            path: `${APP_PREFIX_PATH}/admin/tags/list`,
            title: "sidenav.admin.configuracion.taxonomias",
            icon: TagOutlined,
            breadcrumb: true,
            permission:['Read:tags'],
            submenu: [],
          },
        ],
      },
      {
        key: "Base de datos",
        path: `${APP_PREFIX_PATH}/admin/bd`,
        title: "sidenav.admin.configuracion.basedatos",
        icon: DatabaseOutlined,
        breadcrumb: true,
        permission:['Config:importar'],
        submenu: [
          {
            key: "Importacion",
            path: `${APP_PREFIX_PATH}/admin/bd/importar`,
            title: "sidenav.admin.configuracion.importacion",
            icon: UploadOutlined,
            breadcrumb: true,
            permission:['Config:importar'],
            submenu: [],
          },
          // {
          //   key: "Exportación",
          //   path: `${APP_PREFIX_PATH}/admin/bd/exportar`,
          //   title: "sidenav.admin.configuracion.exportacion",
          //   icon: DownloadOutlined,
          //   breadcrumb: true,
          //   permission:['Config:importar'],
          //   submenu: [],
          // },
          // {
          //   key: "Resumen",
          //   path: `${APP_PREFIX_PATH}/admin/bd/resumen`,
          //   title: "sidenav.admin.configuracion.resumen",
          //   icon: DashboardOutlined,
          //   breadcrumb: true,
          //   permission:['Config:importar'],
          //   submenu: [],
          // },
        ],
      },
    ],
  },
];

export default AdminModuloConfiguracion;
